import styles from "../FirstProductPrompt/FirstProductPrompt.module.scss";
import { Button } from "@blueprintjs/core";
import React from "react";

function CreateProductPrompt({ onVisitProductsClick }) {
  return (
    <div className={styles.firstProductPrompt}>
      <span className={styles.cardTitle}>You'll need a product first!</span>
      <span className={styles.cardMessage}>
        Before you can upload a video, you'll need to either create a product or
        partner with an opportunity to associate with it. Visit your products
        page to create a new product.
      </span>
      <div className={styles.buttons}>
        <Button className="filled narrow" onClick={onVisitProductsClick}>
          Visit Products
        </Button>
      </div>
    </div>
  );
}

export default CreateProductPrompt;
